"use client";

import type { ReactNode } from "react";
import { LanguageProvider } from "@/context/LanguageContext";
import { ThemeProvider } from "@/context/ThemeContext";
import HashSessionHandler from "@/components/auth/HashSessionHandler";

type Props = { children: ReactNode };

export function AppClientProviders({ children }: Props) {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <HashSessionHandler />
        {children}
      </ThemeProvider>
    </LanguageProvider>
  );
}
